import SplashTestimonials from '../lib/SplashTestimonials';

export default {
  init() {
  },
  finalize() {
    fetch('/wp-json/atf/v1/random-testimonials')
      .then(result => result.json())
      .then(data => {
        const testimonials = data.filter(
          testimonial => testimonial.fields
        );

        window.testimonials = testimonials;
        new SplashTestimonials(
          testimonials.map(testimonial => ({
            id: testimonial.ID,
            name: testimonial.fields.author_name,
            title: [testimonial.fields.title_role, testimonial.fields.location]
              .filter(v => v).join(' at '),
            testimonial: testimonial.fields.body,
          }))
        );
      });
    // const quoteArea = document.querySelector('.testimonial-con .quote');
    //
    // const testimonials = [
    //   {
    //     name: 'Jane Doe',
    //     title: 'Dentist at Sesame St',
    //     testimonial: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque nisi iusto veritatis repellat cupiditate impedit consectetur, libero at maiores quo.',
    //   },
    //   {
    //     name: 'John Doe',
    //     title: 'Dental Surgeon',
    //     testimonial: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque nisi iusto veritatis repellat cupiditate impedit consectetur, libero at maiores quo.',
    //   },
    // ];
    //
    // let currentTestimonial = 0;
    //
    // const removeChildNodes = (node) => {
    //   while (node.firstChild) {
    //     node.removeChild(node.lastChild);
    //   }
    // }
    //
    // const setTestimonial = (testimonial) => {
    //   removeChildNodes(quoteArea);
    //
    //   const h3 = document.createElement('h3');
    //   const h4 = document.createElement('h4');
    //   const p = document.createElement('p');
    //
    //   h3.appendChild(document.createTextNode(testimonial.name));
    //   h4.appendChild(document.createTextNode(testimonial.title));
    //   p.appendChild(document.createTextNode(testimonial.testimonial));
    //
    //   quoteArea.appendChild(h3);
    //   quoteArea.appendChild(h4);
    //   quoteArea.appendChild(p);
    // }
    //
    // const testimonialAction = (e, action) => {
    //   e.preventDefault();
    //
    //   if (action === 'left') {
    //     currentTestimonial--;
    //
    //     if (currentTestimonial < 0) {
    //       currentTestimonial = testimonials.length - 1;
    //     }
    //
    //     setTestimonial(testimonials[currentTestimonial]);
    //   }
    //
    //   if (action === 'right') {
    //     currentTestimonial++;
    //
    //     if (currentTestimonial > testimonials.length - 1) {
    //       currentTestimonial = 0;
    //     }
    //
    //     setTestimonial(testimonials[currentTestimonial]);
    //   }
    // }
    //
    // const testimonialInitialization = () => {
    //   quoteArea.classList.remove('disabled');
    //
    //   setTestimonial(testimonials[currentTestimonial]);
    // }
    //
    // document.querySelector('.mobile-testimonial-controls .l-button').addEventListener('click', (e) => { testimonialAction(e, 'left') }, false);
    // document.querySelector('.mobile-testimonial-controls .r-button').addEventListener('click', (e) => { testimonialAction(e, 'right') }, false);
    // document.querySelector('.l-button-desktop').addEventListener('click', (e) => { testimonialAction(e, 'left') }, false);
    // document.querySelector('.r-button-desktop').addEventListener('click', (e) => { testimonialAction(e, 'right') }, false);
    //
    // //TODO: Trigger testimonial init after testimonials are fetched
    // testimonialInitialization();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js